export const vibrate = (pattern?: VibratePattern) => {
  window?.navigator?.vibrate?.(pattern || 300);
};
